import React, { useLayoutEffect, useState, useRef } from 'react';
import StandardChatInput from './StandardChatInput';
import FixedChatInput from './FixedChatInput';
import ConversationStarterButtons from './ConversationStarterButtons';
import CommonQuestionsSection from './CommonQuestionsSection';
import { RenderMode, isSoql } from '../../types';
import { updateComponentOpenState } from '../utils/localStorage';
const ChatInput = ({ mode, renderMode, proxyApp, appContext, actionFunction, updateScrolling, messages, commonQuestions, handleMessageSend, }) => {
    const [searchText, setSearchText] = useState('');
    const [showCommonQuestions, setShowCommonQuestions] = useState(!!commonQuestions && renderMode === RenderMode.FLOATING);
    const textareaRef = useRef(null);
    const enableSoqlBot = isSoql(mode);
    useLayoutEffect(() => {
        if (textareaRef.current) {
            const minHeight = enableSoqlBot ? 40 : 30;
            const maxHeight = enableSoqlBot ? 45 : 34;
            if (textareaRef.current.scrollHeight < maxHeight) {
                textareaRef.current.style.height = `${minHeight}px`;
            }
            else if (textareaRef.current.value === '') {
                textareaRef.current.style.height = 'inherit';
                textareaRef.current.style.height = `${minHeight}px`;
            }
            else {
                textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 10}px `;
            }
            textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
        }
    }, [searchText, textareaRef, enableSoqlBot]);
    const onMessageSend = (questionText) => {
        const inputText = questionText || searchText;
        setSearchText('');
        if (messages.length === 0 && renderMode === RenderMode.FULL_SCREEN) {
            updateComponentOpenState(true);
        }
        if (showCommonQuestions) {
            setShowCommonQuestions(false);
        }
        void handleMessageSend({
            inputText,
            mode,
            actionFunction,
            proxyApp,
            appContext,
            updateScrolling,
        });
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            onMessageSend();
        }
    };
    const commonTextareaProps = {
        placeholder: 'Ask me a question about data',
        value: searchText,
        onChange: (e) => {
            setSearchText(e.target.value);
        },
        onKeyDown: handleKeyDown,
        ref: textareaRef,
    };
    if (renderMode === RenderMode.FLOATING || renderMode === RenderMode.FULL_SCREEN) {
        return (React.createElement("div", null,
            showCommonQuestions && (React.createElement(CommonQuestionsSection, { commonQuestions: commonQuestions, handleCommonQuestionSelection: (questionText) => onMessageSend(questionText) })),
            React.createElement(StandardChatInput, { textareaRef: textareaRef, commonTextareaProps: commonTextareaProps, handleMessageSendClick: () => onMessageSend() }),
            React.createElement(ConversationStarterButtons, { setChatInput: setSearchText, mode: mode, renderMode: renderMode, messages: messages, chatInput: searchText })));
    }
    if (renderMode === RenderMode.FIXED) {
        return React.createElement(FixedChatInput, { textareaRef: textareaRef, commonTextareaProps: commonTextareaProps, handleMessageSendClick: () => onMessageSend() });
    }
    return null;
};
export default ChatInput;
//# sourceMappingURL=ChatInput.js.map